export const PAYMENT_CONFIG = {
    PAID: {
        label: "Paid",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:card-bold",
    },
    UNPAID: {
        label: "Unpaid",
        color: "#991B1B", bg: "#FFF1F2", border: "#FECDD3", dot: "#F43F5E",
        iconName: "solar:card-slash-bold",
    },
    PARTIAL: {
        label: "Partial",
        color: "#92400E", bg: "#FFFBEB", border: "#FDE68A", dot: "#F59E0B",
        iconName: "solar:pie-chart-bold",
    },
    REFUNDED: {
        label: "Refunded",
        color: "#1E3A8A", bg: "#EFF6FF", border: "#BFDBFE", dot: "#60A5FA",
        iconName: "solar:arrow-left-up-bold",
    },
    OVERDUE: {
        label: "Overdue",
        color: "#7C2D12", bg: "#FFF7ED", border: "#FED7AA", dot: "#F97316",
        iconName: "solar:bell-bing-bold",
    },
}